<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6  hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        select-all
        v-bind:pagination.sync="pagination"
        item-key="number"
        :items="bonusComplianceLiquidation"
        :headers="headers"
        class="v-table-list theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th width="1%" class="column"></th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="selected = props.item.number">
            <td width="1%">
               <!--  <v-checkbox :ref="props.index" :value="props.item.number " v-model="additionalGrouped" @change="uniqueCheck(props.item.number, props.index)" primary hide-details :input-value="props.item.number"></v-checkbox> -->
               <v-checkbox hide-details  v-model="selectRow[props.index]" @change="uniqueCheck(props.item.number, props.index)"></v-checkbox>
            </td>
            <td class="text-xs-left cut-text">{{ props.item.creationDate }}</td>
            <td class="text-xs-left cut-text">{{ props.item.number }}</td>
            <td class="text-xs-left cut-text">{{ props.item.vtAgency.toUpperCase() }}</td>
            <td class="text-xs-left cut-text">{{ props.item.apsCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.finalTotalInvoice | currency }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.status }}</td>
            <td class="text-xs-left cut-text" >{{ nzDate(props.item.paymentDate) }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.invoice  }}</td>
            <td v-if="props.item.status === 'Aprobado'">
              <v-btn small color="primary" @click="openFacturarDialog(props.item)">FACTURAR</v-btn>
            </td>
            <td v-if="props.item.status === 'Ingresado' || props.item.status === 'Pagado'">
              <v-icon @click="openDialog(props.item)" style="margin-left: 35px;" color="primary">fa fa-eye</v-icon>

            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
    <FacturarDialog :show="showFacturarDialog" @close="closeFacturarDialog"
    :totalIncome="selectedItem ? selectedItem.finalTotalInvoice : 0" :numberLiquidation="numberLiquidation"/>
     
  <FacturaVisualizaDialog :show="showDialog" :factura="selectedFactura" @close="closeDialog" :numeroLiquidacion="numberLiquidation" :tipo="2" />
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";
import FacturarDialog  from "@/components/Facturacion/FacturarDialog";
import FacturaVisualizaDialog from "@/components/Facturacion/FacturaVisualizaDialog";
export default {
  components: {
    FacturarDialog,
    FacturaVisualizaDialog
  },
  computed: {
    ...mapGetters([
      "loadingBonusCompliance",
      "bonusComplianceLiquidation",
      "agency"
    ])
  },
  mounted() {
    this.$store.dispatch("getBonusComplianceLiquidation");
  },
  methods: {
    nzDate: nzDate,
    /* toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.bonusComplianceLiquidation.slice();
    }, */
    uniqueCheck(e,index){
      let select= this.selectRow[index];
      for(let i=0;i<this.selectRow.length;i++)
      {
        if(index!=i)
        {
          this.selectRow[i]=false;
        }
      }
      if(!this.selectRow[index]){
     this.selectedValue=null;
      }else{
      this.selectedValue=e;
      }
    },
    changeSort(column) {
      this.selectedValue = null;
       this.selectRow= [];
       this.additionalGrouped=[]
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additionalGrouped[0]=this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additionalGrouped[0]=this.selectedValue;
      }
    },
    refresh() {
      this.$store.dispatch("getBonusComplianceLiquidation").then(()=>{
         
          this.selectedValue=null;
          this.additionalGrouped= [];
      });
    },
    enter() {
      this.$store.dispatch("getBonusComplianceLiquidation", this.searchValue);
    },
    openFacturarDialog(item) {
      this.selectedItem = item;
      this.showFacturarDialog = true;
      this.numberLiquidation = item.number;
    },
    closeFacturarDialog() {
      this.showFacturarDialog = false;
      this.selectedItem = null; 
      this.refresh();
    },
    async openDialog(item) {

      // Verifica que el item no sea nulo o indefinido
      if (item) {
        // Asignamos el valor de selectedFactura
        

        // Esperamos hasta que Vue termine de actualizar el DOM
        await this.$nextTick();
        this.numberLiquidation = item.number;

        // Abre el diálogo una vez que todo se haya actualizado
        this.showDialog = true;
      } else {
        console.error("El item no está definido o es nulo.");
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.selectedFactura = null;
    },
  },
  watch: {
    loadingBonusCompliance(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getBonusComplianceLiquidation");
    }
  },
  data() {
    return {
      showDialog: false,
      selectedFactura: null,
      showFacturarDialog: false,
      selectedItem: null,
      selectedValue:null,
      numberLiquidation: '0',
       selectRow:[],
      additionalGrouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate"
      },
      selected: undefined,
      facturarDialog: false,
      facturaField1: "",
      facturaField2: "",
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.date"),
          value: "creationDate",
          width: "19%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.liquidation"),
          value: "number",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.branch"),
          value: "vtAgency",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.agent"),
          value: "apsCode",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.toPay"),
          value: "totalIncome",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "status",
          width: "20%"
        },
         {
          align: "left",
          sortable: true,
          text: i18n.t("message.paymentDate"),
          value: "paymentDate",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.invoice"),
          value: "invoice",
          width: "20%"
        }
      ]
    };
  }
};
</script>